/**
 * Set current step for tabStep
 * @param {Object} state 
 * @param {String} step 
 */
const SET_CURRENT_STEP = (state, step) => {
    state.simulatorSteps.currentStep = step;
}

/**
 * Validate step
 * @param {Object} state 
 * @param {step} step 
 */
const SET_VALIDE_STEP = (state, step) => {
    if(!state.simulatorSteps.validatedSteps.includes(step)) state.simulatorSteps.validatedSteps.push(step)  
}

/**
 * Set dwelling form
 * @param {Object} state 
 * @param {Array} form 
 */
const SET_DWELLING_FORM_QUESTIONS = (state, form) => {
    state.dwelling_tunnel_form = form;
}

/**
 * Set aids form
 * @param {Object} state 
 * @param {Array} form 
 */
const SET_AIDS_FORM_QUESTIONS = (state, form) => {
    state.aids_tunnel_form = form
}

/**
 * Save question answer from user
 * @param {Object} state 
 * @param {Object} questionDatas 
 */
const SET_ANSWER_DATAS = (state, answerDatas) => {
    switch (answerDatas.form) {
        case "dwelling":
            state.answers_dwelling_step[`${answerDatas.key}`] = answerDatas.answer;
            break;
        
        case "lead":
            state.answers_lead_form[`${answerDatas.key}`] = answerDatas.answer;
            break;

        case "aids":
            state.answers_aids_step[`${answerDatas.key}`] = answerDatas.answer;
            break;

        case "saving":
            state.answers_saving_options[`${answerDatas.key}`] = answerDatas.answer;
            break;

        default:
            //ToDO find other solution for "statutForm" last question
            state.answers_dwelling_step[`${answerDatas.key}`] = answerDatas.answer;
            break;
    }
}

/**
 * 
 * @param {Object} state 
 * @param {Object} data 
 */
const SAVE_DWELLING_STEP_RESUME = (state, data) => {
    state.dwelling_step_resume = data;
}

/**
 * Clear answers results
 * @param {Object} state 
 */
const CLEAR_DWELLING_FORM = (state) => {
    state.answers_dwelling_step = {};
}

/**
 * Set Product ID for lead
 * @param {Object} state 
 * @param {String} id 
 */
const SET_LEAD_PRODUCT = (state, id) => {
    state.lead_config.product = id;
}

/**
 * Set category for lead
 * @param {Object} state 
 * @param {String} category 
 */
const SET_LEAD_CATEGORY = (state, category) => {
    state.lead_config.category = category;
}

/**
 * lead first created, need update now
 * @param {Object} state 
 */
const SET_LEAD_CREATED = (state) => {
    state.lead_config.lead_created = true;
}

/**
 * 
 * @param {Object} state 
 * @param {Object} questionDatas 
 */
const SET_PREVIOUS_QUESTION = (state, questionDatas) => {
    state.previousQuestion = {form: questionDatas.form, index:questionDatas.index}
}

/**
 * 
 * @param {Object} state 
 * @param {number} currentStep 
 */
const SPLICE_VALIDATE_STEPS = (state, currentStep) => {
    const delta = (state.simulatorSteps.validatedSteps.length -1) - currentStep;
    state.simulatorSteps.validatedSteps.splice(currentStep+1, delta)
}

/**
 * 
 * @param {Object} state 
 * @param {String} mcpDpe 
 */
const SET_MCP_DPE = (state, mcpDpe) => {
    state.mcp_dpe = mcpDpe;
}

/**
 * Remove question and his answer
 * @param {Object} state 
 * @param {Object} params questionKey - formName
 */
const REMOVE_QUESTION_ANSWER = (state, params) => {
    let questionIndex = state[`${params.formName}_tunnel_form`]?.findIndex(question => question.key === params.questionKey);
    
    // Remove question
    if(questionIndex > 0) state[`${params.formName}_tunnel_form`].splice(questionIndex, 1);

    // Remove answer
    delete state[`answers_${params.formName}_step`][params.questionKey];
}

/**
 * Set information to determine the simulator path
 * @param {Object} state 
 * @param {Object} params infoKey - infoValue
 */
const SET_SIMULATOR_PATH_INFOS = (state, params) => {
    state.simulator_path_infos[`${params.infoKey}`] = params.infoValue;
}


const SET_GTM_EVENTS_DATAS = (state, datas) => {
    if(datas.name) state.gtm_events_datas[`${datas.name}`] = datas;
}

export default {
    SET_DWELLING_FORM_QUESTIONS,
    SET_ANSWER_DATAS,
    CLEAR_DWELLING_FORM,
    SAVE_DWELLING_STEP_RESUME,
    SET_LEAD_CREATED,
    SET_LEAD_PRODUCT,
    SET_LEAD_CATEGORY,
    SET_CURRENT_STEP,
    SET_VALIDE_STEP,
    SET_AIDS_FORM_QUESTIONS,
    SET_PREVIOUS_QUESTION,
    SPLICE_VALIDATE_STEPS,
    SET_MCP_DPE,
    REMOVE_QUESTION_ANSWER,
    SET_SIMULATOR_PATH_INFOS,
    SET_GTM_EVENTS_DATAS
};
